import {
  ActionIcon,
  AppShell,
  Center,
  Group,
  Loader,
  Text,
} from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { Outlet, useLocation } from "react-router";
import { IconMenu2 } from "@tabler/icons-react";
import MainSidebar from "../sidebars/MainSideBar";
import { useLayoutStore } from "../../store/layout.store";
import { useSessionStore } from "../../store/session.store";
import { routePaths } from "../../constants/paths";
import { useAuth } from "../../hooks/useAuth";
import React, { useEffect, useState } from "react";
import RegistrationAsideBarView from "../../views/registration/RegistrationAsideBarView";
import SessionExpiredModal from "../auth/SessionExpiredModal";

export default function DashboardLayout() {
  const location = useLocation();
  const { logoutUser } = useAuth();
  const { asideBarOpened, setAsideBarOpened } = useLayoutStore((state) => state);
  const sessionExpiryDate = useSessionStore((state) => state.sessionExpiryDate);
  const [opened, { toggle }] = useDisclosure();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Close aside bar when navigating away
    setAsideBarOpened(false);
  }, [location.pathname, setAsideBarOpened]);

  useEffect(() => {
    const today = new Date();

    const redirectToLogin = () => {
      const url = `${routePaths.login}`;

      const params = new URLSearchParams();
      params.append("callbackUrl", location.pathname);

      return `${url}?${params.toString()}`;
    };

    if (
      (sessionExpiryDate && new Date(sessionExpiryDate) < today) ||
      !sessionExpiryDate
    ) {
      let redirectUrl = redirectToLogin();

      logoutUser(redirectUrl);
    } else {
      setIsLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionExpiryDate, logoutUser]);

  if (isLoading)
    return (
      <Center h={"100vh"}>
        <Group>
          <Loader color="orange" type="bars" />
          <Text>Loading...</Text>
        </Group>
      </Center>
    );

  return (
    <React.Fragment>
      <SessionExpiredModal />

      <AppShell
        layout="alt"
        navbar={{
          width: 220,
          breakpoint: "md",
          collapsed: { mobile: !opened },
        }}
        aside={{
          width: {base: "100%", md: "30rem", lg: "20rem"},
          breakpoint: "md",
          collapsed: { desktop: !asideBarOpened, mobile: !asideBarOpened },
        }}
      >
        <AppShell.Navbar>
          <MainSidebar toggleSidebar={toggle} isSidebarOpened={opened} />
        </AppShell.Navbar>
        <AppShell.Main>
          <ActionIcon
            variant="subtle"
            hiddenFrom="md"
            color="dark"
            onClick={toggle}
          >
            <IconMenu2 stroke={1.5} size={20} />
          </ActionIcon>
          <Outlet />
        </AppShell.Main>
        <AppShell.Aside>
          {location.pathname === routePaths.register && (
            <RegistrationAsideBarView />
          )}
        </AppShell.Aside>
      </AppShell>
    </React.Fragment>
  );
}
